// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.7803 2H6.71875L5.59375 6.5H9.875V8.5H5.09375L4.46875 11H8.75V13H3.96875L3.34375 15.5H7.625V17.5H2.84375L1.71875 22L21.9995 22V20H12.2803L16.7803 2Z"}}]};

const RulerFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ruler-filled',
    ref,
    icon: element,
  },
));

RulerFilledIcon.displayName = 'RulerFilledIcon';

export default RulerFilledIcon;
